<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QMmQjk/tc-custom/9781646565832.jpg?1723404655476" alt="This image is the cover for the book Watching Cars Go By"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Watching Cars Go By
      </h1>
      <p class="bookDescription body article font2">
        <p>Silke, an easy-going German who prefers dodging problems to facing them, follows her job to the US when her bossy, longtime partner Alex refuses to start a family. Once in Texas, the cute blonde, who fixes medical analyzers for a living, is hit on by coworker Ana, a voluptuous and sexy Latina, who falls head over heels for her.<br/><br/>Ana, formerly content with casual hook-ups, recognizes a good thing when she sees it and will do whatever it takes to win Silke. Still in love with Alex despite her shortcomings, Silke strings Ana along while at the same time getting increasingly chummy with her landlady, Lauren. The frumpy nurse is middle-aged and motherly, and best of all hetero, which makes her safe for Silke to hang out with. Or so she thinks.<br/><br/>A kiss initiated by Lauren changes everything and they eventually become lovers. But Lauren has always struggled with putting herself first, and when her husband and daughter return home for the holidays, she resumes her wife-and-mother persona. Ana, on the other hand, is not only free, she is ready to start a family now and doggedly continues to pursue Silke. Of course there’s also still Alex, sophisticated as ever and used to getting what she wants, which is to keep Silke.<br/><br/>Deceiving everybody and most of all herself, Silke procrastinates until being playful doesn’t cut it any longer. Can she take a stand and save the relationship with the one person who truly matters?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        D.J. Fronimos, Elke Lakey
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?86b32242